import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-批注",
  "use": "icon-批注-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-批注\">\n<path d=\"M136.8 76.0482V114.088C136.8 122.924 129.637 130.088 120.8 130.088H105.213C101.433 130.088 97.776 131.425 94.8887 133.864L85.8208 141.523C79.9881 146.45 71.4874 146.569 65.519 141.808L55.2043 133.58C52.3702 131.319 48.8522 130.088 45.2268 130.088H28C19.1634 130.088 12 122.924 12 114.088V33.9982C12 25.1616 19.1634 17.9982 28 17.9982H82.4377\" stroke=\"#5691F2\" stroke-width=\"10\" stroke-linecap=\"round\" />\n<path d=\"M123.387 10.4L123.815 59.1964\" stroke=\"#5691F2\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M99.2 35.1982H148\" stroke=\"#5691F2\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M44 61.5982H80.8M44 95.1982H104\" stroke=\"#5691F2\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/批注.svg
// module id = otde
// module chunks = 26